<template>
  <div class="min-h-screen bg-carpatina-bg py-12 px-4 animate-fade-in">
    <div class="max-w-4xl mx-auto bg-white rounded-[3rem] shadow-2xl overflow-hidden border-b-8 border-carpatina-verde">
      
      <div class="bg-carpatina-gri p-10 text-white relative">
        <div class="absolute top-0 right-0 p-8 opacity-10">
          <Scale :size="120" />
        </div>
        <h1 class="text-3xl md:text-4xl font-black uppercase tracking-tighter mb-2">Termeni și <span class="text-carpatina-portocaliu">Condiții</span></h1>
        <p class="text-xs font-bold uppercase tracking-widest opacity-60 italic">Ultima actualizare: 9 Martie 2026</p>
      </div>

      <div class="p-8 md:p-12 text-carpatina-gri leading-relaxed space-y-8 font-medium text-sm md:text-base">
        
        <section class="space-y-4">
          <h2 class="text-xl font-black uppercase flex items-center gap-2 text-carpatina-verde">
            <span class="w-1.5 h-6 bg-carpatina-portocaliu inline-block"></span> 1. Dispoziții Generale
          </h2>
          <p>
            Site-ul <strong>Carpatina Prodcom</strong> funcționează ca un catalog digital de prezentare. Accesarea acestuia implică acceptarea termenilor de mai jos. Ne rezervăm dreptul de a modifica acești termeni fără o notificare prealabilă, versiunea valabilă fiind cea afișată în momentul accesării.
          </p>
        </section>

        <section class="space-y-4">
          <h2 class="text-xl font-black uppercase flex items-center gap-2 text-carpatina-verde">
            <span class="w-1.5 h-6 bg-carpatina-portocaliu inline-block"></span> 2. Prețuri și Oferte
          </h2>
          <p>
            Deoarece piața materialelor de construcții este volatilă:
          </p>
          <ul class="list-disc pl-6 space-y-2 italic text-gray-500">
            <li>Prețurile afișate pe site au caracter informativ și pot suferi modificări în funcție de furnizori;</li>
            <li>Prețul final se confirmă <strong>telefonic</strong> sau prin ofertă scrisă în urma solicitării dumneavoastră;</li>
            <li>Produsele marcate cu <em>"Cere Preț"</em> necesită o cotație personalizată în funcție de cantitate și distanța de livrare.</li>
          </ul>
        </section>

        <section class="space-y-4">
          <h2 class="text-xl font-black uppercase flex items-center gap-2 text-carpatina-verde">
            <span class="w-1.5 h-6 bg-carpatina-portocaliu inline-block"></span> 3. Newsletter și Alerte
          </h2>
          <p>
            Prin abonarea la Newsletter sau activarea notificărilor de pe site:
          </p>
          <ul class="list-disc pl-6 space-y-2 italic text-gray-500">
            <li>Vă exprimați acordul de a primi informații comerciale (reduceri, noutăți, modificări de program);</li>
            <li>Ofertele transmise prin alerte (clopoțel) sau email sunt valabile în limita stocului disponibil la momentul respectiv;</li>
            <li>Vă puteți dezabona oricând printr-o solicitare scrisă sau folosind link-ul din email.</li>
          </ul>
        </section>

        <section class="space-y-4">
          <h2 class="text-xl font-black uppercase flex items-center gap-2 text-carpatina-verde">
            <span class="w-1.5 h-6 bg-carpatina-portocaliu inline-block"></span> 4. Solicitarea prin Coșul de Ofertă
          </h2>
          <p>
            Adăugarea produselor în "Lista de Ofertă" (Coș) și trimiterea unei cereri <strong>nu</strong> reprezintă o obligație contractuală de a livra marfa și nu rezervă automat stocul fizic. Contractul se consideră încheiat doar după confirmarea telefonică a disponibilității, prețului final și a condițiilor de transport de către un operator Carpatina Prodcom.
          </p>
        </section>

        <section class="space-y-4">
          <h2 class="text-xl font-black uppercase flex items-center gap-2 text-carpatina-verde">
            <span class="w-1.5 h-6 bg-carpatina-portocaliu inline-block"></span> 5. Asistentul Virtual (ChatBot)
          </h2>
          <p>
            Pentru a vă facilita navigarea, site-ul pune la dispoziție un asistent virtual inteligent. Informațiile tehnice, estimările de cantități sau recomandările oferite de acesta au caracter pur consultativ. Deciziile finale privind achiziția și utilizarea materialelor în șantier trebuie validate împreună cu specialiștii noștri sau cu structuristul lucrării.
          </p>
        </section>

        <section class="space-y-4 border-t border-gray-100 pt-8">
          <div class="bg-carpatina-bg p-6 rounded-2xl border-l-4 border-carpatina-portocaliu text-sm">
            <p class="font-bold text-carpatina-gri mb-2">Notă Importantă:</p>
            <p class="text-gray-500 italic">
              Fotografiile produselor au caracter informativ. Pot exista diferențe minore de nuanță sau ambalaj între imaginile de pe site și produsul fizic livrat, fără a afecta specificațiile tehnice ale acestuia.
            </p>
          </div>
        </section>

      </div>

      <div class="bg-gray-50 p-6 text-center border-t border-gray-100">
        <router-link to="/" class="text-xs font-black text-carpatina-verde hover:text-carpatina-portocaliu transition uppercase tracking-widest flex items-center justify-center gap-2">
          ← Înapoi în Site
        </router-link>
      </div>

    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { Scale } from 'lucide-vue-next';

onMounted(() => {
  document.title = "Termeni și Condiții | Carpatina Prodcom Turnu Măgurele";
  
  const metaDescription = document.querySelector('meta[name="description"]') 
                          || document.createElement('meta');
  metaDescription.name = "description";
  metaDescription.content = "Consultă termenii și condițiile de utilizare ale platformei Carpatina Prodcom. Informații transparente despre prețuri, cereri de ofertă, asistentul virtual și politici de livrare în județul Teleorman.";
  
  if (!document.querySelector('meta[name="description"]')) {
    document.head.appendChild(metaDescription);
  }
});
</script>

<style scoped>
.animate-fade-in { animation: fadeIn 0.5s ease-out; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
</style>